export default "__VITE_ASSET__pLInex2Z__"